<template>
  <InventoryPoView :inventory-po-module-id="moduleIdInstallationPo" />
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import InventoryPoView from '@/views/Inventory/InventoryPoView.vue';

export default {
  components: {
    InventoryPoView,
  },
  props: {

  },
  data: () => ({
    moduleIdInstallationPo: 2,
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  watch: {

  },
  created() {
    this.init();
  },
  methods: {
    init() {

    },
  },
};
</script>

  <style scoped>

  </style>
